/**
 * ? @description : Redux Store
 */

// Dependency
import { configureStore, combineReducers } from "@reduxjs/toolkit";

// Components
import userReducer from "../features/userSlice";
import appReducer from "../features/appSlice";
import templateReducer from "../features/templateSlice"

// TODO : Store Data to Local Storage
const saveToLocalStorage = (state) => {
  try {
    localStorage.setItem("state", JSON.stringify(state));
  } catch (e) {
    console.error(e);
  }
};

// * Get Data from Local Storage
const loadFromLocalStorage = () => {
  try {
    const stateStr = localStorage.getItem("state");
    return stateStr ? JSON.parse(stateStr) : undefined;
  } catch (e) {
    console.error(e);
    return undefined;
  }
};

// TODO : Combine Reducers
const rootReducer = combineReducers({
  user: userReducer,
  app: appReducer,
  templates: templateReducer
});

// * Function Call to Get Data from Local Storage
const persistedStore = loadFromLocalStorage();

// ! App Store
const store = configureStore({
  reducer: rootReducer,
  preloadedState: persistedStore,
});

// TODO : App Subscribe
store.subscribe(() => {
  saveToLocalStorage(store.getState());
});

export default store;
